<template>
  <div class="sinh-tu-wrapper">
    <div v-if="isSubmitting" class="overlay-loading">
      <div class="loader"></div>
    </div>
    <div class="row-2col">
      <div class="input-group">
        <label class="input-title"><span class="icon">📅</span> Ngày</label>
        <div class="input-box">
          <input type="date" v-model="date" />
        </div>
      </div>

      <div class="input-group">
        <label class="input-title"><span class="icon">💰</span> Ting Ting</label>
        <div class="ting-ting-box">
          <button @click="decreaseTingTing">‹</button>
          <span class="ting-ting-value">{{ tingTing }}K</span>
          <button @click="increaseTingTing">›</button>
        </div>
        <div
          v-if="selectedPlayers.length === 2"
          class="ting-ting-note"
        >
          Tương đương = {{ tingTing / 2 }}K/Player
        </div>
      </div>
    </div>  

    <PlayerList v-model="selectedPlayers" />

    <button
      class="submit-button"
      :disabled="!canSubmit"
      @click="handleSubmit"
    >
      GHI DANH
    </button>
  </div>
</template>

<script>
import PlayerList from './PlayerList.vue';

export default {
  name: "SoSinhTu",
  components: { PlayerList },
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      tingTing: 20,
      selectedPlayers: [],
      isSubmitting: false
    };
  },
  computed: {
    canSubmit() {
      return this.selectedPlayers.length === 1 || this.selectedPlayers.length === 2;
    }
  },
  methods: {
    handleSubmit() {
      this.isSubmitting = true;
      const payload = {
        player1: this.selectedPlayers[0],
        player2: this.selectedPlayers.length === 2 ? this.selectedPlayers[1] : null,
        betDate: this.date,
        betAmount: this.tingTing
      };

      const apiUrl = 'https://script.google.com/macros/s/AKfycbx4On0Fs2eKWdPyCS_SnIGvzuwdU6oTMYEYDxhUR5UTub5-NzzJoiDXv92H1nCU5sKPrw/exec'; //APIv1.1
      const params = new URLSearchParams({
        action: 'submitBet',
        playerId1: payload.player1.playerId,
        playerId2: payload.player2 ? payload.player2.playerId : '',
        betDate: payload.betDate,
        betAmount: payload.betAmount
      });
      const url = `${apiUrl}?${params.toString()}`;
      
      fetch(url)
        .then((res) => res.json())
        .then((data) => {
          this.isSubmitting = false;
          if (data.success) {
            alert("🎉 Ghi danh thành công!");
            this.selectedPlayers = [];
          } else {
            alert("⚠️ Ghi danh thất bại: " + JSON.stringify(data));
          }
        })
        .catch((err) => {
          this.isSubmitting = false;
          console.error('Lỗi ghi:', err);
          alert("❌ Lỗi khi gửi dữ liệu!");
        });
    },

    increaseTingTing() {
      if (this.tingTing < 100) this.tingTing += 10;
    },
    decreaseTingTing() {
      if (this.tingTing > 10) this.tingTing -= 10;
    }
  },
  // mounted() removed: no caching or fetching logic required
};
</script>

<style scoped>
/* Giữ nguyên style cũ */
.sinh-tu-wrapper {
  max-width: 480px;
  background-color: white;
  justify-content: center;
}

.input-group {
  width: 90%;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: stretch;
  justify-content: center;
  align-items: baseline;
}

.input-title {
  font-weight: bold;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.input-box input {
  width: 90%;
  padding: 10px 10px;
  font-size: 17.5px;
  border: 1px solid #ccc;
  border-radius: 10px;
  height: 25px;
  font-family: sans-serif;
  font-weight: bold;
  text-align: center;
}

.ting-ting-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px 10px;
  font-weight: bold;
  font-size: 16px;
  width: 90%;
  height: 25px;
}

.ting-ting-box button {
  background: none;
  border: none;
  font-size: 30px;
  cursor: pointer;
  padding-bottom: 5px;
}

.ting-ting-value {
  font-size: 18px;
  font-weight: 700;
}

.ting-ting-note {
  text-align: center;
  font-size: 14px;
  color: #999;
  margin-top: 4px;
}

.thank-you-text {
  position: fixed;
  bottom: 100px;
  left: 0;
  right: 0;
  text-align: center;
  color: #9acc00;
  font-weight: bold;
  font-size: 16px;
  z-index: 998;
}

.submit-button {
  position: fixed;
  bottom: 30px;
  left: 0;
  right: 0;
  margin: 0 auto;
  max-width: 480px;
  width: calc(100% - 48px);
  padding: 14px;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: bold;
  background: #7ed300;
  color: white;
  cursor: pointer;
  z-index: 999;
}

.submit-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  box-shadow: none;
}

.row-2col {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 40px;
}

.overlay-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loader {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #7ed300;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
